import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
// Constants
// import { getProtocolTitle } from "../../../../config/validateProtocols";
// Components
import {
  Container,
  Header,
  HeaderText,
  HeaderStatus,
  DisplayCanvasButton,
  DisplayCanvasImg,
  DataDiv,
  ColumnDataDiv,
  InputDataDiv,
  Label,
  Input,
  DescriptionText,
  Textarea,
  RecurringMessageButton,
  RecurringMessageBall,
  PrescriptionDaysDiv,
  FlexDiv,
  SelectAllText,
  SelectAllButton,
  SelectAllImg,
  PrescriptionsSeparator,
  DayText,
  InputCheckboxDiv,
  InputCheckbox,
  VerifyCheckboxImg,
  DateInputDiv,
  DateInput,
  ActionButtonsDiv,
  SaveButton,
  CancelButton,
  DeleteButton,
  DeleteImg,
  DeleteText,
  ReactTooltipStyled,
} from "./styles";
// import Select from "../../../selectInput";
import UpdateMessageButton from "../updateMessage";
import DeleteMessage from "../deleteMessage";
// Assets
import ArrowDownImg from "../../../../assets/icons/ico_arrow_down_blue.svg";
import ArrowUpImg from "../../../../assets/icons/ico_arrow_up_blue.svg";
// import SelectArrow from "../../../../assets/icons/ico_arrow_down.svg";
import CheckboxAllBlue from "../../../../assets/icons/ico_checkbox_full_blue.svg";
import CheckboxAllGray from "../../../../assets/icons/ico_checkbox_full_gray.svg";
import CheckboxEmptyBlue from "../../../../assets/icons/ico_checkbox_empty_blue.svg";
import CheckboxEmptyGray from "../../../../assets/icons/ico_checkbox_empty_gray.svg";
import CheckDisabled from "../../../../assets/icons/ico_checkbox_disabled.svg";
import CheckTrue from "../../../../assets/icons/ico_checkbox_true.svg";
import CheckFalse from "../../../../assets/icons/ico_checkbox_false.svg";
import DeleteIcon from "../../../../assets/icons/btn_delete_user.svg";

const MessageCanvas = ({
  title,
  isOnlyDisplayed,
  patientProtocols,
  COACH_MESSAGES_ID,
  COACH_MESSAGES_PER_PATIENT_ID,
  COACH_MESSAGES_PER_PROTOCOL_ID,
  messageType,
  setMessageType,
  protocolId,
  setProtocolId,
  messageText,
  setMessageText,
  showOnlyOnce,
  setShowOnlyOnce,
  launchDays,
  setLaunchDays,
  launchTime,
  setLaunchTime,
  deleteTime,
  setDeleteTime,
  setIsShowingMessageForm,
  saveMessage,
  setIsLoadingMessages,
  isUpdateCanvas,
  isShowingUpdateMessageForm,
  rechargeMessages,
  setRechargeMessages,
}) => {
  const [isShowingCanvas, setIsShowingCanvas] = useState(false);
  const [isShowingDeleteCanvas, setIsShowingDeleteCanvas] = useState(false);
  const [t] = useTranslation("global");

  useEffect(() => {
    setIsShowingDeleteCanvas(false);
  }, [isShowingUpdateMessageForm]);

  const colorByMessageType = {
    NOTIFICATION: "#F199CE",
    GREETING: "#B3A4EE",
    ON_PROTOCOL: "#73B0F4",
  };

  const descriptionByMessageType = {
    NOTIFICATION: t("coachMessages_messageTypeDescription_NOTIFICATION"),
    GREETING: t("coachMessages_messageTypeDescription_GREETING"),
    ON_PROTOCOL: t("coachMessages_messageTypeDescription_ON_PROTOCOL"),
  };

  const renderStatus = () => {
    let statusColor;
    let statusText;
    let statusDescription;

    if (!deleteTime || (!showOnlyOnce && deleteTime && new Date(deleteTime) > new Date())) {
      statusColor = "#fbb03b";
      statusText = t("coachMessages_status_active");
      statusDescription = t("coachMessages_statusDescription_active");
    }

    if (showOnlyOnce && deleteTime && new Date(deleteTime) > new Date()) {
      statusColor = "#c2c2c2";
      statusText = t("coachMessages_status_pending");
      statusDescription = t("coachMessages_statusDescription_pending");
    }

    if (deleteTime && new Date(deleteTime) < new Date()) {
      statusColor = "#39b54a";
      statusText = t("coachMessages_status_sent");
      statusDescription = t("coachMessages_statusDescription_sent");
    }

    return (
      <>
        <ReactTooltipStyled id="messageStatus" place="top" type="dark" effect="solid" delayShow={100} delayHide={100} />
        <HeaderStatus data-for="messageStatus" data-tip={statusDescription} color={statusColor}>
          {statusText}
        </HeaderStatus>
      </>
    );
  };

  // const renderMessageTypesOptions = () => {
  //   return (
  //     <Select
  //       value={messageType}
  //       onChange={(e) => setMessageType(e.target.value)}
  //       padding="5px 35px 5px 10px"
  //       width="200px"
  //       arrowImg={SelectArrow}
  //       backgroundPosition="175px center"
  //       disabled={!isOnlyDisplayed || isUpdateCanvas}
  //     >
  //       <option value={"NOTIFICATION"}>{t("coachMessages_notification")}</option>
  //       <option value={"GREETING"}>{t("coachMessages_greeting")}</option>
  //       <option value={"ON_PROTOCOL"}>{t("coachMessages_onProtocol")}</option>
  //     </Select>
  //   );
  // };

  // const renderProtocolOptions = () => {
  //   return (
  //     <Select
  //       value={protocolId}
  //       onChange={(e) => setProtocolId(e.target.value)}
  //       padding="5px 35px 5px 10px"
  //       width="200px"
  //       arrowImg={SelectArrow}
  //       backgroundPosition="175px center"
  //       disabled={!isOnlyDisplayed}
  //     >
  //       <option value={false}></option>
  //       {patientProtocols.map((protocolId) => {
  //         return (
  //           <option key={protocolId} value={protocolId}>
  //             {t(getProtocolTitle("protocols", protocolId))}
  //           </option>
  //         );
  //       })}
  //     </Select>
  //   );
  // };

  const renderProtocolDays = () => {
    const isAllDaysSelected = () => {
      return (
        launchDays.includes("MONDAY") &&
        launchDays.includes("TUESDAY") &&
        launchDays.includes("WEDNESDAY") &&
        launchDays.includes("THURSDAY") &&
        launchDays.includes("FRIDAY") &&
        launchDays.includes("SATURDAY") &&
        launchDays.includes("SUNDAY")
      );
    };

    const setDayCheckbox = (day) => {
      let launchDaysClone = JSON.parse(JSON.stringify(launchDays));
      const isTheDayAdded = launchDaysClone.find((launchDay) => launchDay === day);
      if (!isTheDayAdded) {
        launchDaysClone.push(day);
        return setLaunchDays(launchDaysClone);
      }
      if (isTheDayAdded) {
        const findDayIndex = launchDaysClone.findIndex((launchDay) => launchDay === day);
        launchDaysClone.splice(findDayIndex, 1);
        return setLaunchDays(launchDaysClone);
      }
    };

    const addMissingDays = () => {
      let launchDaysToSet = JSON.parse(JSON.stringify(launchDays));
      !launchDaysToSet.includes("MONDAY") && launchDaysToSet.push("MONDAY");
      !launchDaysToSet.includes("TUESDAY") && launchDaysToSet.push("TUESDAY");
      !launchDaysToSet.includes("WEDNESDAY") && launchDaysToSet.push("WEDNESDAY");
      !launchDaysToSet.includes("THURSDAY") && launchDaysToSet.push("THURSDAY");
      !launchDaysToSet.includes("FRIDAY") && launchDaysToSet.push("FRIDAY");
      !launchDaysToSet.includes("SATURDAY") && launchDaysToSet.push("SATURDAY");
      !launchDaysToSet.includes("SUNDAY") && launchDaysToSet.push("SUNDAY");
      return setLaunchDays(launchDaysToSet);
    };

    const setAllDaysCheckbox = () => {
      if (isAllDaysSelected()) {
        setLaunchDays([]);
      } else {
        addMissingDays();
      }
    };

    const renderEachDay = () => {
      const days = [
        {
          label: t("prescriptions_tableProtocolDays_monday"),
          dayToSet: "MONDAY",
        },
        {
          label: t("prescriptions_tableProtocolDays_tuesday"),
          dayToSet: "TUESDAY",
        },
        {
          label: t("prescriptions_tableProtocolDays_wednesday"),
          dayToSet: "WEDNESDAY",
        },
        {
          label: t("prescriptions_tableProtocolDays_thursday"),
          dayToSet: "THURSDAY",
        },
        {
          label: t("prescriptions_tableProtocolDays_friday"),
          dayToSet: "FRIDAY",
        },
        {
          label: t("prescriptions_tableProtocolDays_saturday"),
          dayToSet: "SATURDAY",
        },
        {
          label: t("prescriptions_tableProtocolDays_sunday"),
          dayToSet: "SUNDAY",
        },
      ];
      return days.map((day) => {
        return (
          <FlexDiv key={day.dayToSet}>
            <DayText>{day.label}</DayText>
            <InputCheckboxDiv>
              <InputCheckbox
                type="checkbox"
                value={launchDays.includes(day.dayToSet)}
                onClick={() => setDayCheckbox(day.dayToSet)}
                disabled={!isOnlyDisplayed || showOnlyOnce}
              />
              {launchDays.includes(day.dayToSet) && !isOnlyDisplayed ? (
                <VerifyCheckboxImg src={CheckDisabled} alt="check-disabled" />
              ) : launchDays.includes(day.dayToSet) ? (
                <VerifyCheckboxImg src={CheckTrue} alt="check-true" />
              ) : (
                <VerifyCheckboxImg src={CheckFalse} alt="check-false" />
              )}
            </InputCheckboxDiv>
          </FlexDiv>
        );
      });
    };

    return (
      <PrescriptionDaysDiv>
        <FlexDiv>
          <SelectAllText>{t("coachMessages_checkAllDays")}</SelectAllText>
          <SelectAllButton onClick={setAllDaysCheckbox} disabled={!isOnlyDisplayed || showOnlyOnce}>
            <SelectAllImg
              src={
                !isOnlyDisplayed || showOnlyOnce
                  ? isAllDaysSelected()
                    ? CheckboxAllGray
                    : CheckboxEmptyGray
                  : isAllDaysSelected()
                  ? CheckboxAllBlue
                  : CheckboxEmptyBlue
              }
              alt="select-all-prescriptions"
            />
          </SelectAllButton>
        </FlexDiv>
        <PrescriptionsSeparator />
        {renderEachDay()}
      </PrescriptionDaysDiv>
    );
  };

  return (
    <>
      {isShowingDeleteCanvas ? (
        <DeleteMessage
          COACH_MESSAGES_PER_PATIENT_ID={COACH_MESSAGES_PER_PATIENT_ID}
          setIsShowingDeleteCanvas={setIsShowingDeleteCanvas}
          setIsLoadingMessages={setIsLoadingMessages}
          rechargeMessages={rechargeMessages}
          setRechargeMessages={setRechargeMessages}
        />
      ) : (
        <Container borderLeft={colorByMessageType[messageType]}>
          <Header>
            <HeaderText width={isOnlyDisplayed ? "auto" : "225px"} showAlways={true}>
              {title}
            </HeaderText>
            {(!isOnlyDisplayed || isUpdateCanvas) && (
              <HeaderText width="125px">{deleteTime ? moment(deleteTime).format("DD/MM/YYYY") : t("coachMessages_undefined")}</HeaderText>
            )}
            {(!isOnlyDisplayed || isUpdateCanvas) && renderStatus()}
            {!isOnlyDisplayed && isShowingCanvas && (
              <UpdateMessageButton
                patientProtocols={patientProtocols}
                COACH_MESSAGES_ID={COACH_MESSAGES_ID}
                COACH_MESSAGES_PER_PATIENT_ID={COACH_MESSAGES_PER_PATIENT_ID}
                COACH_MESSAGES_PER_PROTOCOL_ID={COACH_MESSAGES_PER_PROTOCOL_ID}
                currentMessageType={messageType}
                currentProtocolId={protocolId}
                currentMessageText={messageText}
                currentShowOnlyOnce={showOnlyOnce}
                currentLaunchDays={launchDays}
                currentLaunchTime={launchTime}
                currentDeleteTime={deleteTime}
                setIsLoadingMessages={setIsLoadingMessages}
                rechargeMessages={rechargeMessages}
                setRechargeMessages={setRechargeMessages}
              />
            )}
            {!isOnlyDisplayed && (
              <DisplayCanvasButton onClick={() => setIsShowingCanvas(!isShowingCanvas)}>
                <DisplayCanvasImg src={isShowingCanvas ? ArrowUpImg : ArrowDownImg} alt="ico-arrow" />
              </DisplayCanvasButton>
            )}
          </Header>
          {(isOnlyDisplayed || isShowingCanvas) && (
            <>
              <DataDiv addTopBorder addBottomBorder>
                {/* <ColumnDataDiv width="385px">
                  <InputDataDiv>
                    <Label fontWeight="bold">{t("coachMessages_messageTypeText")} *</Label>
                    {renderMessageTypesOptions()}
                  </InputDataDiv>
                  {messageType === "ON_PROTOCOL" && (
                    <InputDataDiv activeAnimation>
                      <Label fontWeight="bold">{t("activity")} *</Label>
                      {renderProtocolOptions()}
                    </InputDataDiv>
                  )}
                </ColumnDataDiv> */}
                <ColumnDataDiv width="100%">
                  <DescriptionText>{descriptionByMessageType[messageType]}</DescriptionText>
                </ColumnDataDiv>
              </DataDiv>
              <DataDiv addBottomBorder={isOnlyDisplayed}>
                <ColumnDataDiv width="385px">
                  <InputDataDiv alignItems="flex-start">
                    <Label htmlFor="message" fontWeight="bold">
                      {t("coachMessages_message")} *
                    </Label>
                    <Textarea
                      id="message"
                      value={messageText}
                      onChange={(e) => setMessageText(e.target.value)}
                      disabled={!isOnlyDisplayed}
                    />
                  </InputDataDiv>
                </ColumnDataDiv>
                <ColumnDataDiv width="385px">
                  <InputDataDiv>
                    <Label fontWeight="bold">{t("coachMessages_recurrentMessage")} *</Label>
                    <RecurringMessageButton
                      disabled={!isOnlyDisplayed}
                      showOnlyOnce={showOnlyOnce}
                      onClick={() => setShowOnlyOnce(!showOnlyOnce)}
                    >
                      <RecurringMessageBall showOnlyOnce={showOnlyOnce}></RecurringMessageBall>
                    </RecurringMessageButton>
                  </InputDataDiv>
                  {!showOnlyOnce && renderProtocolDays()}
                  {messageType === "NOTIFICATION" && (
                    <InputDataDiv>
                      <Label fontWeight="bold">{t("coachMessages_launchTime")} *</Label>
                      <Input type="time" value={launchTime} onChange={(e) => setLaunchTime(e.target.value)} disabled={!isOnlyDisplayed} />
                    </InputDataDiv>
                  )}
                  <InputDataDiv>
                    <Label fontWeight="bold">
                      {showOnlyOnce ? `${t("coachMessages_launchDate")} *` : `${t("coachMessages_endingDate")}`}
                    </Label>
                    <DateInputDiv>
                      <DateInput
                        placeholderText={showOnlyOnce ? `${t("dd/mm/yyyy")}` : `${t("coachMessages_undefined")}`}
                        selected={deleteTime ? new Date(moment(deleteTime).format("YYYY-MM-DD")) : deleteTime}
                        onChange={(date) => setDeleteTime(date)}
                        dateFormat={"dd/MM/yyyy"}
                        disabled={!isOnlyDisplayed}
                      />
                    </DateInputDiv>
                  </InputDataDiv>
                </ColumnDataDiv>
              </DataDiv>
              {isOnlyDisplayed && (
                <ActionButtonsDiv>
                  <SaveButton onClick={saveMessage}>{t("save")}</SaveButton>
                  <CancelButton onClick={() => setIsShowingMessageForm(false)}>{t("cancel")}</CancelButton>
                  {isUpdateCanvas && (
                    <DeleteButton onClick={() => setIsShowingDeleteCanvas(true)}>
                      <DeleteImg src={DeleteIcon} alt="delete-ico" />
                      <DeleteText>{t("coachMessages_deleteMessage")}</DeleteText>
                    </DeleteButton>
                  )}
                </ActionButtonsDiv>
              )}
            </>
          )}
        </Container>
      )}
    </>
  );
};

export default MessageCanvas;
